"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.ModalContainer = exports.MessagesWrapper = exports.IconWrapper = exports.IconTextWrapper = exports.Footer = exports.Container = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
const Wrapper = exports.Wrapper = _styledComponents.default.div.withConfig({
  displayName: "SessionModalstyle__Wrapper",
  componentId: "sc-b4sgry-0"
})(["display:flex;justify-content:center;width:100%;"]);
const Container = exports.Container = _styledComponents.default.div.withConfig({
  displayName: "SessionModalstyle__Container",
  componentId: "sc-b4sgry-1"
})(["display:flex;justify-content:left;flex-direction:column;padding:", " ", " 0;"], _uiKit.theme.spacing.BASE_2, _uiKit.theme.spacing.BASE_10);
const Footer = exports.Footer = _styledComponents.default.div.withConfig({
  displayName: "SessionModalstyle__Footer",
  componentId: "sc-b4sgry-2"
})(["display:flex;width:100%;justify-content:end;button{margin-left:", ";background-color:", ";color:", ";&:first-child{margin-left:0;}}"], _uiKit.theme.spacing.BASE_2, _uiKit.theme.colours.BUTTON_PRIMARY, _uiKit.theme.colours.WHITE);
const IconWrapper = exports.IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "SessionModalstyle__IconWrapper",
  componentId: "sc-b4sgry-3"
})(["position:relative;margin:0 auto;"]);
const MessagesWrapper = exports.MessagesWrapper = _styledComponents.default.div.withConfig({
  displayName: "SessionModalstyle__MessagesWrapper",
  componentId: "sc-b4sgry-4"
})(["display:flex;align-items:left;flex-direction:column;text-align:left !important;text-align:center;line-height:12px;letter-spacing:0.4px;padding:", " 0;svg{padding-right:", ";}> div{display:flex;align-items:center;:first-child > div{font-weight:", ";padding-bottom:", ";}:last-child{padding-top:", ";}}"], _uiKit.theme.spacing.BASE_3, _uiKit.theme.spacing.BASE_1, _uiKit.theme.fonts.weight.BOLD, _uiKit.theme.spacing.BASE_3, _uiKit.theme.spacing.BASE_3);
const IconTextWrapper = exports.IconTextWrapper = _styledComponents.default.div.withConfig({
  displayName: "SessionModalstyle__IconTextWrapper",
  componentId: "sc-b4sgry-5"
})(["display:flex;flex-direction:row;align-self:flex-start;"]);
const ModalContainer = exports.ModalContainer = _styledComponents.default.div.withConfig({
  displayName: "SessionModalstyle__ModalContainer",
  componentId: "sc-b4sgry-6"
})(["position:absolute;top:-200px;"]);